// ─── Single source of truth for all pricing display values ──────────────────
// Used by: studio-v2 (billing page), web (pricing page + homepage)
// Outreach unit prices MUST match apps/backend/src/constants/outreach-billing.ts
// (canonical cents values, enforced by code review — change both together).
// payPerUse/oneOff prices MUST match the live Stripe Prices
// (apps/backend/src/config/stripe.config.ts holds the Price IDs).
export const PRICING = {
    // Pay-as-you-go consumables, in USD.
    payPerUse: {
        session: 25, // AI Pitch Session; first one is free (FREE_PITCH_SESSION flag)
        evaluation: 2, // Custom fund evaluation
    },
    // Outreach engagement billing, in USD. Mirrors outreach-billing.ts constants.
    outreach: {
        view: 0, // tracked, not charged
        returnVisit: 0, // tracked, not charged
        bookedCall: 10,
        warmIntro: 10,
        minDeposit: 50, // "$50 to start" — minimum wallet deposit
    },
    // One-off non-consumable products.
    oneOff: {
        investorMatchesUnlock: {
            name: 'Investor matches unlock',
            // Display value approved for the website. The charged amount lives on the
            // Stripe Price (INVESTOR_MATCHES_UNLOCK in stripe.config.ts) — confirm it
            // is $10 before launch and keep the two in sync.
            price: 10,
        },
    },
};
//# sourceMappingURL=pricing.js.map